<template>
    <div>
        <v-tabs v-model="tab" class="mb-4">
            <v-tab>Иконки</v-tab>
            <v-tab>Лента</v-tab>
            <v-tab>Информпанель</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card class="pa-4" :loading="loading">
                    <v-card-title class="px-0">
                        <span class="text-h5">Иконки соцсетей</span>
                    </v-card-title>

                    <v-card-text class="px-0">
                        <p class="mb-4 text--secondary">
                            Ссылка на паблик задаётся один раз и подставляется во все места вывода.
                            Показ и значок (SVG) настраиваются отдельно для шапки, подвала и бургер-меню.
                        </p>
                        <input
                            ref="svgInput"
                            type="file"
                            accept=".svg,image/svg+xml"
                            class="d-none"
                            @change="uploadSvg"
                        >

                        <div class="settings-block mb-6">
                            <div class="text-subtitle-1 font-weight-bold mb-2">Ссылки на паблики</div>
                            <v-row dense>
                                <v-col
                                    v-for="network in networks"
                                    :key="network.code"
                                    cols="12"
                                    md="6"
                                >
                                    <v-text-field
                                        v-model="network.url"
                                        :label="network.name"
                                        :rules="[urlRule]"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </div>

                        <div
                            v-for="place in places"
                            :key="place.code"
                            class="settings-block mb-6"
                        >
                            <div class="d-flex align-center mb-2">
                                <div class="text-subtitle-1 font-weight-bold">{{ place.name }}</div>
                                <v-switch
                                    v-model="place.enabled"
                                    class="ml-4 mt-0 pt-0"
                                    :label="place.enabled ? 'Показывается' : 'Скрыто'"
                                    dense
                                    hide-details
                                    inset
                                ></v-switch>
                            </div>

                            <v-row
                                v-for="icon in place.icons"
                                :key="icon.network"
                                dense
                                align="center"
                                class="settings-icon-row"
                            >
                                <v-col cols="12" sm="3">
                                    <v-checkbox
                                        v-model="icon.enabled"
                                        :label="networkName(icon.network)"
                                        dense
                                        hide-details
                                        class="mt-0 pt-0"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="9">
                                    <div class="d-flex align-center svg-field">
                                        <div class="svg-preview">
                                            <img
                                                v-if="icon.svg"
                                                :src="svgSrc(icon.svg)"
                                                alt=""
                                            >
                                        </div>
                                        <v-text-field
                                            v-model="icon.svg"
                                            label="Ссылка на SVG"
                                            :rules="[svgRule]"
                                            dense
                                            outlined
                                            hide-details="auto"
                                            class="mx-3"
                                        ></v-text-field>
                                        <v-btn
                                            small
                                            outlined
                                            color="primary"
                                            :loading="uploading === `${place.code}:${icon.network}`"
                                            @click="pickFile(place.code, icon.network)"
                                        >
                                            Загрузить
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>

                    <v-card-actions class="px-0">
                        <v-btn
                            color="primary"
                            :loading="saving"
                            :disabled="loading || !isValid"
                            @click="save"
                        >
                            Сохранить
                        </v-btn>
                        <v-btn
                            text
                            :disabled="loading || saving"
                            @click="getSettings"
                        >
                            Отменить изменения
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>

            <v-tab-item>
                <v-card class="pa-4" :loading="feedLoading">
                    <v-card-title class="px-0">
                        <span class="text-h5">Лента новостей</span>
                    </v-card-title>

                    <v-card-text class="px-0">
                        <p class="mb-4 text--secondary">
                            Блок собирает свежие публикации с сайтов ведомств и городов. Показываются
                            новости за последние сутки (сколько — ниже), но не больше указанного
                            числа. Источники опрашиваются автоматически каждые 10 минут.
                            «Обойти сейчас» проверяет сохранённый адрес источника — так можно
                            убедиться, что он читается, до включения.
                        </p>

                        <div class="settings-block mb-6">
                            <div class="d-flex align-center mb-4">
                                <div class="text-subtitle-1 font-weight-bold">Блок «Лента»</div>
                                <v-switch
                                    v-model="feed.enabled"
                                    class="ml-4 mt-0 pt-0"
                                    :label="feed.enabled ? 'Показывается' : 'Скрыт'"
                                    dense
                                    hide-details
                                    inset
                                ></v-switch>
                            </div>
                            <v-row dense>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model.number="feed.ringSize"
                                        label="Максимум новостей в ленте"
                                        type="number"
                                        min="5"
                                        max="200"
                                        hint="Старые вытесняются новыми"
                                        persistent-hint
                                        :rules="[ringSizeRule]"
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model.number="feed.windowDays"
                                        label="Показывать новости за последние, суток"
                                        type="number"
                                        min="1"
                                        max="30"
                                        hint="2 — сегодня и вчера; что старше, скрывается"
                                        persistent-hint
                                        :rules="[windowDaysRule]"
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-switch
                                        v-model="feed.shuffle"
                                        class="mt-0 pt-1"
                                        label="Вперемешку"
                                        hint="Порядок случайный (меняется раз в 5 минут), чтобы карточки не примелькались"
                                        persistent-hint
                                        dense
                                        inset
                                    ></v-switch>
                                </v-col>
                            </v-row>
                        </div>

                        <div
                            v-for="source in feed.sources"
                            :key="source.code"
                            class="settings-block mb-4"
                        >
                            <v-row dense align="center">
                                <v-col cols="12" sm="4">
                                    <v-checkbox
                                        v-model="source.enabled"
                                        :label="source.name"
                                        dense
                                        hide-details
                                        class="mt-0 pt-0"
                                    ></v-checkbox>
                                    <v-chip x-small class="ml-8" outlined>
                                        {{ parserLabel(source.parser) }}
                                    </v-chip>
                                </v-col>
                                <v-col cols="12" sm="8">
                                    <v-text-field
                                        v-model="source.url"
                                        label="Адрес источника"
                                        :rules="[urlRule]"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-checkbox
                                v-model="source.browserUa"
                                label="Представляться браузером (если сайт отвечает 403 на обычный запрос)"
                                dense
                                hide-details
                                class="mt-1 pt-0"
                            ></v-checkbox>
                            <div class="mt-2 text-caption text--secondary">
                                <template v-if="source.lastError">
                                    <span class="error--text">
                                        Последний обход {{ source.lastCheckedAt || '—' }}: {{ source.lastError }}
                                    </span>
                                </template>
                                <template v-else-if="source.lastCheckedAt">
                                    Последний обход {{ source.lastCheckedAt }}, взято новостей:
                                    {{ source.lastItemsCount === null ? '—' : source.lastItemsCount }}
                                </template>
                                <template v-else>
                                    Обходов ещё не было
                                </template>
                                <span v-if="source.errorStreak > 1" class="error--text ml-2">
                                    Ошибок подряд: {{ source.errorStreak }}
                                </span>
                            </div>
                            <div class="mt-2">
                                <v-btn
                                    small
                                    outlined
                                    :loading="!!feedFetching[source.code]"
                                    :disabled="feedLoading || feedSaving"
                                    @click="fetchSourceNow(source)"
                                >
                                    Обойти сейчас
                                </v-btn>
                                <v-btn
                                    v-if="!source.builtin"
                                    small
                                    text
                                    color="error"
                                    class="ml-2"
                                    :disabled="feedLoading || feedSaving"
                                    @click="deleteFeedSource(source)"
                                >
                                    Удалить
                                </v-btn>
                            </div>
                        </div>

                        <div class="settings-block mb-2">
                            <div class="text-subtitle-1 font-weight-bold mb-3">Добавить источник</div>
                            <v-row dense>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        v-model="newSource.name"
                                        label="Название"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <v-text-field
                                        v-model="newSource.url"
                                        label="Адрес RSS-ленты или страницы со списком новостей"
                                        :rules="[urlRule]"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select
                                        v-model="newSource.parser"
                                        :items="parserItems"
                                        label="Тип"
                                        dense
                                        outlined
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <div class="mt-2 text-caption text--secondary">
                                Работает для сайтов с RSS или с микроразметкой schema.org (NewsArticle).
                                Остальным сайтам нужен отдельный разбор в коде. Источник добавляется
                                выключенным: сначала нажмите «Обойти сейчас» и проверьте результат.
                            </div>
                            <v-btn
                                small
                                color="primary"
                                class="mt-3"
                                :loading="feedAdding"
                                :disabled="feedLoading || feedSaving || !isNewSourceValid"
                                @click="addFeedSource"
                            >
                                Добавить
                            </v-btn>
                        </div>
                    </v-card-text>

                    <v-card-actions class="px-0">
                        <v-btn
                            color="primary"
                            :loading="feedSaving"
                            :disabled="feedLoading || !isFeedValid"
                            @click="saveFeed"
                        >
                            Сохранить
                        </v-btn>
                        <v-btn
                            text
                            :disabled="feedLoading || feedSaving"
                            @click="getFeedSettings"
                        >
                            Отменить изменения
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>

            <v-tab-item>
                <v-card class="pa-4" :loading="panelLoading">
                    <v-card-title class="px-0">
                        <span class="text-h5">Разделы в информпанели</span>
                    </v-card-title>

                    <v-card-text class="px-0">
                        <p class="mb-4 text--secondary">
                            Разделы новостей в тёмной полосе шапки — рядом с «Новостями», курсами и погодой.
                            Порядок меняется перетаскиванием за значок слева. На телефоне те же разделы
                            показываются в бургер-меню.
                        </p>

                        <div class="settings-block mb-4">
                            <draggable
                                v-model="panel.selected"
                                handle=".drag-handle"
                                ghost-class="ghost-drag-block"
                            >
                                <div
                                    v-for="id in panel.selected"
                                    :key="id"
                                    class="d-flex align-center panel-section"
                                >
                                    <v-icon class="mr-2 drag-handle">$drag</v-icon>
                                    <span class="flex-grow-1">{{ tagName(id) }}</span>
                                    <v-btn icon small color="error" @click="removeSection(id)">
                                        <v-icon small>$close</v-icon>
                                    </v-btn>
                                </div>
                            </draggable>
                            <p v-if="!panel.selected.length" class="text--secondary mb-0">
                                Разделы не выбраны — в шапке останутся только «Новости».
                            </p>
                        </div>

                        <v-select
                            v-model="sectionToAdd"
                            :items="availableTags"
                            item-text="name"
                            item-value="id"
                            label="Добавить раздел"
                            dense
                            outlined
                            hide-details
                            :disabled="!availableTags.length"
                            @change="addSection"
                        ></v-select>
                    </v-card-text>

                    <v-card-actions class="px-0">
                        <v-btn
                            color="primary"
                            :loading="panelSaving"
                            :disabled="panelLoading"
                            @click="savePanel"
                        >
                            Сохранить
                        </v-btn>
                        <v-btn
                            text
                            :disabled="panelLoading || panelSaving"
                            @click="getPanelSettings"
                        >
                            Отменить изменения
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
// Какие адреса SVG принимает бэкенд: свой путь или внешняя https-ссылка.
const SVG_RE = /^(\/social-icons\/svg\/[a-z0-9]{2,40}\.svg|https:\/\/\S+)$/;

import Draggable from "vuedraggable";

export default {
    name: "Settings",
    components: {
        Draggable,
    },
    data() {
        return {
            tab: 0,
            loading: false,
            saving: false,
            networks: [],
            places: [],
            uploading: null,
            uploadTarget: null,
            panelLoading: false,
            panelSaving: false,
            panel: {
                selected: [],
                tags: [],
            },
            sectionToAdd: null,
            feedLoading: false,
            feedSaving: false,
            feed: {
                enabled: false,
                ringSize: 50,
                windowDays: 2,
                shuffle: true,
                sources: [],
            },
            feedFetching: {},
            feedAdding: false,
            newSource: { name: "", url: "", parser: "rss" },
            parserItems: [
                { text: "RSS-лента", value: "rss" },
                { text: "Страница со списком (schema.org)", value: "schema" },
            ],
        };
    },
    computed: {
        isValid() {
            const svgOk = this.places.every(place => place.icons.every(icon => SVG_RE.test(icon.svg || '')));
            const urlsOk = this.networks.every(network => /^https?:\/\/\S+$/.test(network.url || ''));

            return svgOk && urlsOk;
        },
        // Разделы, которых ещё нет в информпанели, — для выпадающего списка «Добавить»
        availableTags() {
            return this.panel.tags.filter(tag => !this.panel.selected.includes(tag.id));
        },
        isFeedValid() {
            const urlsOk = this.feed.sources.every(source => /^https?:\/\/\S+$/.test(source.url || ''));

            return urlsOk
                && this.windowDaysRule(this.feed.windowDays) === true
                && this.ringSizeRule(this.feed.ringSize) === true;
        },
        isNewSourceValid() {
            return this.newSource.name.trim() !== ""
                && /^https?:\/\/\S+$/.test(this.newSource.url.trim());
        },
    },
    mounted() {
        this.getSettings();
        this.getFeedSettings();
        this.getPanelSettings();
    },
    methods: {
        async getSettings() {
            this.loading = true;

            try {
                const { networks, places } = await this.$api("/admin/social-icons");
                this.networks = networks;
                this.places = places;
            } catch (e) {
                this.$error(e.message);
            }

            this.loading = false;
        },
        async save() {
            this.saving = true;

            try {
                const { networks, places } = await this.$api("/admin/social-icons", {
                    method: "POST",
                    body: {
                        networks: this.networks.map(({ code, url }) => ({ code, url })),
                        places: this.places.map(({ code, enabled, icons }) => ({
                            code,
                            enabled,
                            icons: icons.map(({ network, enabled, svg }) => ({
                                network,
                                enabled,
                                svg,
                            })),
                        })),
                    },
                });
                this.networks = networks;
                this.places = places;
                this.$success("Настройки сохранены");
            } catch (e) {
                this.$error(e.message);
            }

            this.saving = false;
        },
        async getPanelSettings() {
            this.panelLoading = true;

            try {
                this.panel = await this.$api("/admin/info-panel");
            } catch (e) {
                this.$error(e.message);
            }

            this.panelLoading = false;
        },
        async savePanel() {
            this.panelSaving = true;

            try {
                this.panel = await this.$api("/admin/info-panel", {
                    method: "POST",
                    body: { selected: this.panel.selected },
                });
                this.$success("Разделы информпанели сохранены");
            } catch (e) {
                this.$error(e.message);
            }

            this.panelSaving = false;
        },
        tagName(id) {
            const tag = this.panel.tags.find(item => item.id === id);

            return tag ? tag.name : `#${id}`;
        },
        addSection(id) {
            if (id && !this.panel.selected.includes(id)) {
                this.panel.selected.push(id);
            }
            this.$nextTick(() => {
                this.sectionToAdd = null;
            });
        },
        removeSection(id) {
            this.panel.selected = this.panel.selected.filter(item => item !== id);
        },
        async getFeedSettings() {
            this.feedLoading = true;

            try {
                this.feed = await this.$api("/admin/feed-settings");
            } catch (e) {
                this.$error(e.message);
            }

            this.feedLoading = false;
        },
        async saveFeed() {
            this.feedSaving = true;

            try {
                this.feed = await this.$api("/admin/feed-settings", {
                    method: "POST",
                    body: {
                        enabled: this.feed.enabled,
                        ringSize: this.feed.ringSize,
                        windowDays: this.feed.windowDays,
                        shuffle: this.feed.shuffle,
                        sources: this.feed.sources.map(({ code, url, enabled, browserUa }) => ({
                            code, url, enabled, browserUa,
                        })),
                    },
                });
                this.$success("Настройки ленты сохранены");
            } catch (e) {
                this.$error(e.message);
            }

            this.feedSaving = false;
        },
        windowDaysRule(value) {
            const n = Number(value);

            return (Number.isInteger(n) && n >= 1 && n <= 30) || "От 1 до 30 суток";
        },
        parserLabel(parser) {
            return { rss: "RSS", schema: "Список (schema.org)" }[parser] || "HTML-список";
        },
        // После добавления/удаления с сервера приходит вся вкладка. Несохранённые правки
        // адресов и галочек у остальных источников не теряем — переносим их на свежий список.
        mergeSources(serverSources) {
            const local = new Map(this.feed.sources.map(source => [source.code, source]));

            return serverSources.map(source => {
                const mine = local.get(source.code);

                return mine
                    ? { ...source, url: mine.url, enabled: mine.enabled, browserUa: mine.browserUa }
                    : source;
            });
        },
        async addFeedSource() {
            this.feedAdding = true;

            try {
                const settings = await this.$api("/admin/feed-settings/sources", {
                    method: "POST",
                    body: { ...this.newSource, name: this.newSource.name.trim(), url: this.newSource.url.trim() },
                });
                this.feed = { ...this.feed, sources: this.mergeSources(settings.sources) };
                this.newSource = { name: "", url: "", parser: "rss" };
                this.$success("Источник добавлен (выключен). Проверьте его кнопкой «Обойти сейчас»");
            } catch (e) {
                this.$error(e.message);
            }

            this.feedAdding = false;
        },
        async deleteFeedSource(source) {
            if (!window.confirm(`Удалить источник «${source.name}» вместе с его новостями в ленте?`)) {
                return;
            }

            try {
                const settings = await this.$api(`/admin/feed-settings/sources/${source.code}`, {
                    method: "DELETE",
                });
                this.feed = { ...this.feed, sources: this.mergeSources(settings.sources) };
                this.$success("Источник удалён");
            } catch (e) {
                this.$error(e.message);
            }
        },
        // Обход одного источника. Обновляем только его телеметрию — несохранённые
        // правки адреса и галочек остаются как были.
        async fetchSourceNow(source) {
            this.$set(this.feedFetching, source.code, true);

            try {
                const { report, settings } = await this.$api(
                    `/admin/feed-settings/sources/${source.code}/fetch`,
                    { method: "POST" },
                );
                const fresh = settings.sources.find(item => item.code === source.code);
                if (fresh) {
                    source.lastCheckedAt = fresh.lastCheckedAt;
                    source.lastItemsCount = fresh.lastItemsCount;
                    source.lastError = fresh.lastError;
                    source.errorStreak = fresh.errorStreak;
                }
                if (report.error) {
                    this.$error(`${report.source}: ${report.error}`);
                } else {
                    this.$success(`${report.source}: добавлено новостей — ${report.added}`);
                }
            } catch (e) {
                this.$error(e.message);
            }

            this.$set(this.feedFetching, source.code, false);
        },
        ringSizeRule(value) {
            const n = Number(value);

            return (Number.isInteger(n) && n >= 5 && n <= 200) || 'От 5 до 200 новостей';
        },
        networkName(code) {
            const network = this.networks.find(item => item.code === code);

            return network ? network.name : code;
        },
        svgRule(value) {
            return SVG_RE.test(value || '') || 'Загрузите файл или укажите https-ссылку на SVG';
        },
        // Свои пути (/social-icons/svg/…) отдаёт api — для превью добавляем его адрес.
        svgSrc(svg) {
            return svg.startsWith('/') ? `${process.env.VUE_APP_API}${svg}` : svg;
        },
        pickFile(placeCode, network) {
            this.uploadTarget = { placeCode, network };
            this.$refs.svgInput.value = '';
            this.$refs.svgInput.click();
        },
        async uploadSvg(event) {
            const file = event.target.files && event.target.files[0];
            const target = this.uploadTarget;
            if (!file || !target) {
                return;
            }
            this.uploading = `${target.placeCode}:${target.network}`;

            try {
                const body = new FormData();
                body.append('file', file);
                const r = await fetch(`${process.env.VUE_APP_API}/admin/social-icons/upload`, {
                    method: 'POST',
                    headers: { token: this.$store.state.auth.token },
                    body,
                });
                const data = await r.json().catch(() => ({}));
                if (!r.ok) {
                    throw new Error(data.error || 'Не удалось загрузить файл');
                }
                const place = this.places.find(p => p.code === target.placeCode);
                const icon = place && place.icons.find(i => i.network === target.network);
                if (icon) {
                    icon.svg = data.url;
                }
                this.$success('Файл загружен — не забудьте сохранить');
            } catch (e) {
                this.$error(e.message);
            }

            this.uploading = null;
        },
        urlRule(value) {
            return /^https?:\/\/\S+$/.test(value || '') || 'Ссылка должна начинаться с http:// или https://';
        },
    },
};
</script>

<style scoped>
    .settings-block {
        border: 1px solid #e2e8f0;
        border-radius: 10px;
        padding: 16px;
    }

    /* Превью значка рядом с полем ссылки */
    .svg-preview {
        flex: 0 0 36px;
        width: 36px;
        height: 36px;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .svg-preview img {
        width: 24px;
        height: 24px;
        display: block;
    }

    .panel-section {
        padding: 6px 4px;
        border-bottom: 1px solid #f1f5f9;
    }

    .panel-section:last-child {
        border-bottom: none;
    }

    .settings-icon-row + .settings-icon-row {
        margin-top: 8px;
    }
</style>
